import { render, staticRenderFns } from "./v-tab.vue?vue&type=template&id=16097dc4"
import script from "./v-tab.vue?vue&type=script&lang=js"
export * from "./v-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports